import React,{useRef, useState} from 'react'
import './contact.css'
import {ContactData} from './Data'
import emailjs from '@emailjs/browser'

const Contact = () => {
    const form = useRef();
    const [show,setShow] = useState(false)

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_fxcubsp', 'template_y821eab', form.current, 'f5soGOPYU6Y7cH4Ga').
        then(() => {
            e.target.reset();
            setTimeout(()=>{
                setShow(true);
            },4000)
        }, (error) => {
            alert('OOPS! SOMETHING HAS FAILED...' , error)
        });
    };

    setTimeout(()=>{
        setShow(false);
    },8000)

    return (
    <>
        <section className="contact section" id="contact">
                <h2 className="section__title">Contact Me</h2>
                <span className="section__subtitle">Get in touch</span>

                <div className="contact__container container grid section__border">
                    <div className="contact__content">
                        <h3 className="contact__title">
                            <i className="ri-chat-3-line"></i> Talk to me
                        </h3>

                        <div className="contact__info">
                            {
                                ContactData.map((item,index)=>{
                                    return(
                                        <div className="contact__data" key={index}>
                                            <span className="contact__data-title">{item.Title}</span>
                                            <span className="contact__data-info">{item.Info}</span>
                                            <a href={item.LinkMail} rel="noreferrer" target="_blank" className="contact__button contact__button-eng">
                                                Write me
                                                <i className="ri-arrow-right-line"></i>
                                            </a>
                                        </div>
                                    )
                                })
                            }
                        </div>

                    </div>

                    <div className="contact__content">
                        <h3 className="contact__title">
                            <i className="ri-send-plane-line"></i> Write me your project
                        </h3>

                        <form ref={form} onSubmit={sendEmail} className="contact__form" id="contact-form">
                            <div className="contact__form-div">
                                <label className="contact__form-tag contact__form-tag-eng">Names</label>
                                <input autocomplete="off" name="name" required placeholder="Write your names" type="text" className="contact__form-input contact__form-input-eng" id="contact-name"/>
                            </div>

                            <div className="contact__form-div">
                                <label className="contact__form-tag contact__form-tag-eng">Mail</label>
                                <input autocomplete="off" name="email" required placeholder="Write your email" type="email" className="contact__form-input contact__form-input-eng" id="contact-email"/>
                            </div>

                            <div className="contact__form-div contact__form-area">
                                <label className="contact__form-tag contact__form-tag-eng">Project</label>
                                <textarea autocomplete="off" name="message" placeholder="Write your project" className="contact__form-input contact__form-input-eng" id="contact-project"></textarea>
                            </div>

                            <p className={show ? 'contact__message color-blue' : 'contact__message'}>
                                Message {show ? 'Sent' : ''}
                            </p>

                            <button type="submit" className="contact__button contact__button-eng">
                                Submit <i className="ri-arrow-right-up-line"></i>
                            </button>
                        </form>
                    </div>
                </div>
        </section>
    </>
    )
}

export default Contact